import React, { useEffect, useState } from 'react'

import Header from '../Core/Header'
import { hospital } from '../../Assets/dummyHospital'
import { useSelector } from 'react-redux'
import { getAllHospitals } from '../../Services/Operations/ProductAPI'

const FindHospitals = () => {
     const[list,setList]=useState(hospital)
      const token = useSelector((state) =>JSON.parse( state.auth.token));
      const [hospitals,setHospitals]=useState([])

      const handleHospitalList=async()=>{
        try {
            const res= await getAllHospitals(token)
            console.log(res);
            if(res.status===200){
                setHospitals(res.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
      }

      useEffect(() => {
        handleHospitalList()
      }, [])
      
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
     <section
  style={{
    marginTop: "80px",
    height: "calc(100vh - 80px)",
    boxSizing: "border-box",
    padding: "clamp(12px, 2vw, 26px)",
    background: "linear-gradient(135deg, #eef2f7 0%, #f8fafc 55%, #e2e8f0 100%)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    fontFamily: "Inter, system-ui, sans-serif",
  }}
>
  {/* Header */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "14px",
      padding: "18px 22px",
      background: "linear-gradient(135deg, #102a43, #1e4566)",
      borderRadius: "16px",
      boxShadow: "0 8px 24px rgba(15, 42, 67, 0.15)",
      flexShrink: 0,
    }}
  >
    <div style={{ minWidth: 0 }}>
      <p
        style={{
          margin: 0,
          color: "#bae6fd",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "1.8px",
          textTransform: "uppercase",
        }}
      >
        Hospital Management
      </p>

      <h2
        style={{
          margin: "6px 0 0",
          color: "#ffffff",
          fontSize: "clamp(21px, 2.5vw, 28px)",
          fontWeight: 750,
          lineHeight: 1.3,
        }}
      >
        All Hospitals
      </h2>

      <p
        style={{
          margin: "5px 0 0",
          color: "#cbd5e1",
          fontSize: "13px",
        }}
      >
        View registered hospitals and their details
      </p>
    </div>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flex: "1 1 260px",
        maxWidth: "390px",
        minWidth: 0,
        padding: "0 12px",
        height: "46px",
        boxSizing: "border-box",
        background: "#ffffff",
        border: "1px solid #dbeafe",
        borderRadius: "11px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
      }}
    >
      <span style={{ fontSize: "18px", color: "#64748b" }}>⌕</span>

      <input
        placeholder="Search hospital by Aadhaar"
        onChange={(e) => {
          // Connect this to your existing search state if needed.
        }}
        style={{
          width: "100%",
          minWidth: 0,
          height: "100%",
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: "14px",
          color: "#0f172a",
        }}
      />
    </div>
  </div>

  {/* Hospital count */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "8px",
      padding: "18px 4px 12px",
      flexShrink: 0,
    }}
  >
    <p
      style={{
        margin: 0,
        fontSize: "14px",
        color: "#475569",
        fontWeight: 600,
      }}
    >
      Registered hospitals
    </p>

    <span
      style={{
        padding: "6px 12px",
        background: "#dbeafe",
        color: "#1d4ed8",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: 750,
      }}
    >
      {hospitals.length} Hospitals
    </span>
  </div>

  {/* Scrollable responsive hospital grid */}
  <div
    style={{
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: "4px 4px 18px",
      scrollbarWidth: "thin",
      scrollbarColor: "#94a3b8 transparent",
    }}
  >
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 265px), 1fr))",
        gap: "18px",
        alignItems: "stretch",
      }}
    >
      {hospitals.map((item, index) => (
        <div
          key={item?.id || item?.license_number || index}
          style={{
            minWidth: 0,
            boxSizing: "border-box",
            borderRadius: "17px",
            padding: "12px",
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            boxShadow: "0 5px 18px rgba(15,23,42,0.06)",
            display: "flex",
            flexDirection: "column",
            gap: "13px",
            transition: "box-shadow 0.2s ease, transform 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 12px 28px rgba(15,23,42,0.12)";
            e.currentTarget.style.transform = "translateY(-3px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow =
              "0 5px 18px rgba(15,23,42,0.06)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Hospital image */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "165px",
              overflow: "hidden",
              borderRadius: "12px",
              background: "#e2e8f0",
            }}
          >
            <img
              src="/Assets/diagonasitic.jpg"
              alt={item?.hospital_name || "Hospital"}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />

            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "25px 11px 10px",
                background:
                  "linear-gradient(transparent, rgba(15,23,42,0.78))",
                color: "#ffffff",
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "1px",
              }}
            >
              REGISTERED HOSPITAL
            </div>
          </div>

          {/* Hospital name */}
          <div style={{ minWidth: 0 }}>
            <h3
              title={item?.hospital_name || ""}
              style={{
                margin: 0,
                fontSize: "18px",
                lineHeight: 1.45,
                fontWeight: 750,
                color: "#172033",
                overflowWrap: "anywhere",
              }}
            >
              {item?.hospital_name || "Unnamed Hospital"}
            </h3>
          </div>

          {/* Address */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "9px",
              padding: "11px",
              background: "#f8fafc",
              borderRadius: "10px",
              border: "1px solid #edf2f7",
            }}
          >
            <span style={{ fontSize: "17px", flexShrink: 0 }}>📍</span>

            <div style={{ minWidth: 0 }}>
              <p
                style={{
                  margin: "0 0 4px",
                  color: "#64748b",
                  fontSize: "10px",
                  fontWeight: 750,
                  letterSpacing: "0.8px",
                  textTransform: "uppercase",
                }}
              >
                Hospital Address
              </p>

              <p
                style={{
                  margin: 0,
                  color: "#334155",
                  fontSize: "13px",
                  lineHeight: 1.6,
                  overflowWrap: "anywhere",
                }}
              >
                {item?.address || "Address not available"}
              </p>
            </div>
          </div>

          {/* Registration / license */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <span
              style={{
                color: "#64748b",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              License Number
            </span>

            <span
              style={{
                maxWidth: "100%",
                padding: "5px 9px",
                background: "#eff6ff",
                border: "1px solid #dbeafe",
                borderRadius: "7px",
                color: "#1d4ed8",
                fontSize: "11px",
                fontWeight: 750,
                overflowWrap: "anywhere",
              }}
            >
              REG: {item?.license_number || "N/A"}
            </span>
          </div>

          <div
            style={{
              height: "1px",
              background: "#e2e8f0",
              width: "100%",
            }}
          />

          {/* Medical tests */}
          <div>
            <p
              style={{
                margin: "0 0 9px",
                fontSize: "13px",
                fontWeight: 750,
                color: "#334155",
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}
            >
              <span style={{ fontSize: "16px" }}>🩺</span>
              Medical Tests Provided
            </p>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {/* Replace with actual test data when available */}
              {Array.isArray(item?.medical_tests) &&
              item.medical_tests.length > 0 ? (
                item.medical_tests.map((test, i) => (
                  <span
                    key={`${test}-${i}`}
                    style={{
                      padding: "5px 8px",
                      borderRadius: "7px",
                      background: "#ecfdf5",
                      border: "1px solid #d1fae5",
                      color: "#047857",
                      fontSize: "11px",
                      fontWeight: 600,
                      overflowWrap: "anywhere",
                    }}
                  >
                    {test}
                  </span>
                ))
              ) : (
                <span
                  style={{
                    color: "#94a3b8",
                    fontSize: "12px",
                    fontStyle: "italic",
                  }}
                >
                  No test details available
                </span>
              )}
            </div>
          </div>

          {/* Assigned hospitals */}
          <div>
            <p
              style={{
                margin: "0 0 9px",
                fontSize: "13px",
                fontWeight: 750,
                color: "#334155",
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}
            >
              <span style={{ fontSize: "16px" }}>🏥</span>
              Assigned Hospital
            </p>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {Array.isArray(item?.AssignedHospital) &&
              item.AssignedHospital.length > 0 ? (
                item.AssignedHospital.map((hospital, i) => (
                  <span
                    key={`${hospital}-${i}`}
                    style={{
                      padding: "5px 8px",
                      borderRadius: "7px",
                      background: "#f5f3ff",
                      border: "1px solid #ede9fe",
                      color: "#6d28d9",
                      fontSize: "11px",
                      fontWeight: 600,
                      overflowWrap: "anywhere",
                    }}
                  >
                    {hospital}
                  </span>
                ))
              ) : (
                <span
                  style={{
                    color: "#94a3b8",
                    fontSize: "12px",
                    fontStyle: "italic",
                  }}
                >
                  No assigned hospitals
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Empty state */}
    {hospitals.length === 0 && (
      <div
        style={{
          padding: "55px 20px",
          textAlign: "center",
          color: "#64748b",
        }}
      >
        <div style={{ fontSize: "42px", marginBottom: "12px" }}>🏥</div>
        <p
          style={{
            margin: 0,
            fontSize: "18px",
            color: "#334155",
            fontWeight: 750,
          }}
        >
          No hospitals found
        </p>
        <p style={{ fontSize: "13px" }}>
          Hospital records will appear here when available.
        </p>
      </div>
    )}
  </div>
</section>
    </div>
  )
}

export default FindHospitals
